"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import * as f from "react";
import O from "classnames";
import { useIsInverseVariant as R, ThemeVariant as V } from "./theme-variant-context.js";
import { getPrefixedDataAttributes as I } from "./utils/dom.js";
import { vars as n } from "./skins/skin-contract.css-mistica.js";
import { boxed as D, desktopOnly as W, boxBorder as $, vars as i } from "./boxed.css-mistica.js";
import { sprinkles as l } from "./sprinkles.css-mistica.js";
import { applyCssVars as j } from "./utils/css.js";
const z = (o, r)=>o || r ? l({
        border: "none"
    }) : $, s = (o)=>typeof o == "number" ? `${o}px` : o !== null && o !== void 0 ? o : "initial", e = (o, r)=>{
    if (typeof r == "number" || typeof r == "string" || typeof r > "u") return {
        [i[o]]: s(r)
    };
    const t = {
        [i.mobile[o]]: s(r.mobile),
        [i.desktop[o]]: s(r.desktop)
    };
    return r.tablet && (t[i.tablet[o]] = s(r.tablet)), t;
}, A = /*#__PURE__*/ f.forwardRef((param, w)=>{
    let { children: o, isInverse: r = !1, className: t, role: p, dataAttributes: b, "aria-label": c, "aria-labelledby": y, width: h, maxWidth: x, minWidth: g, height: k, minHeight: u, borderRadius: B = n.borderRadii.container, background: d, desktopOnly: C } = param;
    const m = R();
    return /* @__PURE__ */ a("div", _object_spread_props(_object_spread({
        ref: w,
        style: _object_spread_props(_object_spread({}, j(_object_spread({}, e("width", h), e("maxWidth", x), e("minWidth", g), e("height", k), e("minHeight", u)))), {
            background: d
        }),
        className: O(t, D, z(m, r), l({
            borderRadius: B,
            overflow: "hidden",
            background: (d !== null && d !== void 0 ? d : r) ? m ? n.colors.backgroundContainerBrandOverInverse : n.colors.backgroundContainerBrand : n.colors.backgroundContainer
        }), {
            [W]: C
        }),
        role: p,
        "aria-label": c,
        "aria-labelledby": y
    }, I(b)), {
        children: /* @__PURE__ */ a(V, {
            isInverse: r,
            children: o
        })
    }));
}), J = /*#__PURE__*/ f.forwardRef((o, r)=>/* @__PURE__ */ a(A, _object_spread_props(_object_spread({}, o), {
        ref: r
    })));
export { J as Boxed, A as InternalBoxed };
